import {Component, Input, OnInit} from '@angular/core';
import {QuestionBase} from "../../../../create-adv/models/question-base";

@Component({
    selector: 'app-text-box-input',
    templateUrl: './text-box-input.component.html',
    styleUrls: ['./text-box-input.component.scss'],
    standalone: false
})
export class TextBoxInputComponent implements OnInit {
  @Input() question: QuestionBase<string>;
  @Input() value: string;
  constructor() { }

  ngOnInit(): void {
  }

  // SCRUM-145: never interpolate an object ("[object Object]") — unwrap
  // lookup-table values ({ id, Type } / { label } / { name } ...) to text.
  get displayValue(): string {
    const val: any = this.question?.value;
    if (val === null || val === undefined || val === '') return '';
    if (typeof val !== 'object') return String(val);
    return val.label ?? val.name ?? val.Type ?? val.nameHe ?? val.value?.name ?? val.value?.value ?? '';
  }

}
